<replay-web-page id="warc-viewer" [source]="originalSourceUrl"></replay-web-page>
